import React from 'react';
import { GraduationCap, Tablet, Target } from 'lucide-react';

const FeaturesSection = () => {
  return (
    <section className="container mx-auto px-4 py-16 text-center">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {/* First card: Cá nhân hóa */}
        <div className="flex flex-col items-center p-6 bg-white rounded-xl shadow-md">
          <div className="p-4 bg-purple-100 rounded-full mb-4">
            <Target size={48} className="text-purple-600" />
          </div>
          <h3 className="text-xl font-bold text-gray-800 mb-2">Cá nhân hóa</h3>
          <p className="text-gray-600">Học sinh giỏi sẽ học nhanh và sâu, học sinh trung bình sẽ học chậm và chắc.</p>
        </div>

        {/* Second card: Dễ học dễ hiểu */}
        <div className="flex flex-col items-center p-6 bg-white rounded-xl shadow-md">
          <div className="p-4 bg-blue-100 rounded-full mb-4">
            <GraduationCap size={48} className="text-blue-600" />
          </div>
          <h3 className="text-xl font-bold text-gray-800 mb-2">Dễ học dễ hiểu</h3>
          <p className="text-gray-600">Bài giảng và hệ thống bài tập được biên soạn chỉnh chu.</p>
        </div>

        {/* Third card: Học linh hoạt */}
        <div className="flex flex-col items-center p-6 bg-white rounded-xl shadow-md">
          <div className="p-4 bg-green-100 rounded-full mb-4">
            <Tablet size={48} className="text-green-600" />
          </div>
          <h3 className="text-xl font-bold text-gray-800 mb-2">Học linh hoạt</h3>
          <p className="text-gray-600">Học mọi lúc mọi nơi, chỉ cần có kết nối internet.</p>
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
